<template>
  <button
    class="scishield-button"
    @click.stop.prevent="$emit('click')"
    v-if="enablePrevent"
  >
    <slot></slot>
  </button>
  <button class="scishield-button" @click.passive="$emit('click')" v-else>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "VButton",
  props: {
    enablePrevent: { type: Boolean, default: false },
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
.scishield-button.tray-button {
  margin-left: 0;
  box-shadow: none;
  background: none;
  cursor: pointer;
  height: 1rem;
  width: max-content;
  padding: 0 1rem;
  font-size: var(--font-size-50);
}

.scishield-button.tray-button.red {
  color: var(--red-800);
}

.scishield-button.tray-button.gray {
  color: var(--gray-500);
}

.scishield-button.primary {
  --default-color: var(--blue-900);
  --hover-color: var(--blue-1000);
  --active-color: var(--blue-1100);
}

.scishield-button.destructive {
  --default-color: var(--red-900);
  --hover-color: var(--red-1000);
  --active-color: var(--red-1100);
}

.scishield-button.info {
  --default-color: var(--blue-600);
  --hover-color: var(--blue-700);
  --active-color: var(--blue-800);
}
.scishield-button.warning {
  --default-color: var(--yellow-600);
  --hover-color: var(--yellow-700);
  --active-color: var(--yellow-800);
}
.scishield-button.errorRed {
  --default-color: var(--red-600);
  --hover-color: var(--red-700);
  --active-color: var(--red-800);
}
.scishield-button.success {
  --default-color: var(--green-600);
  --hover-color: var(--green-700);
  --active-color: var(--green-800);
}
.scishield-button.subtle {
  color: white;
  background: none;
}
.scishield-button.pill-primary:hover {
  border-color: var(--hover-color);
  background-color: var(--default-color);
}
.scishield-button.pill-primary:active {
  background-color: var(--active-color);
  border-color: var(--gray-900);
}
.scishield-button.pill-primary {
  --default-color: white;
  --hover-color: var(--gray-800);
  --active-color: var(--gray-600);
  color: var(--gray-900);
  border: 2px solid var(--gray-900);
}
.scishield-button.pill-selected {
  --default-color: var(--gray-900);
  --hover-color: var(--gray-800);
  --active-color: var(--gray-600);
}
.scishield-button.clear {
  margin-left: 0;
  box-shadow: none;
  color: var(--red-800);
  background: none;
}

.scishield-button {
  background-image: none;
  background-color: var(--default-color);
  border: 2px solid var(--default-color);
  border-radius: 2.53125rem;
  color: var(--gray-50);
  height: 2rem;
  line-height: 1;
  padding: 0 2rem;
  font-family: var(--font-system-ui, sans-serif);
  font-weight: 400;
  font-size: var(--font-size-100);
  position: relative;
  transition: all 0.2s ease;
  box-shadow: var(--drop-shadow-gray);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
}

.scishield-button.white {
  --default-color: transparent;
  --hover-color: var(--gray-50);
  --active-color: var(--gray-50);
  border-color: var(--gray-50);
}

.scishield-button.white:hover {
  color: var(--gray-900);
}

.scishield-button.small {
  font-size: var(--font-size-75, 0.875rem);
}
.scishield-button.xsmall {
  font-size: var(--font-size-50);
}

.scishield-button:hover {
  background-color: var(--hover-color);
  border-color: var(--hover-color);
}

.scishield-button:active {
  background-color: var(--active-color);
  border-color: var(--active-color);
}

.scishield-button.ghost,
.scishield-button.ghost:hover,
.scishield-button.ghost:active {
  background: none;
}

.scishield-button.ghost {
  color: var(--default-color);
}

.scishield-button.ghost:hover {
  color: var(--hover-color);
}

.scishield-button.ghost:active {
  color: var(--active-color);
}

.scishield-button.disabled {
  background-color: var(--gray-500);
  border-color: var(--gray-500);
  color: var(--gray-100);
  cursor: auto;
}

.scishield-button.outline:hover {
  color: rgb(235, 37, 60);
  border-color: rgb(235, 37, 60);
}

.scishield-button.outline.disabled {
  border-color: var(--gray-600);
  color: rgb(7, 9, 23);
}

.scishield-button.icon-right {
  padding-right: 3.125rem;
}

.scishield-button svg {
  position: absolute;
  right: 1rem;
  top: calc(50% - 0.625rem);
}

.scishield-button.clear.disabled {
  color: var(--gray-500);
  background: none;
  cursor: auto;
}
</style>
